// Text as 2D outlines for manifold-3d (numbers on the advent shelves). Font: three.js'
// helvetiker bold (MgOpen, free to use and distribute).

import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js'
import fontJson from 'three/examples/fonts/helvetiker_bold.typeface.json'

let font = null
const getFont = () => (font ||= new FontLoader().parse(fontJson))

/**
 * CrossSection of `text` with its letters `size` mm tall, centred on (0, 0), reading along
 * +x with +y up.
 */
export function textSection(CrossSection, text, size) {
  const shapes = getFont().generateShapes(String(text), size)
  const polys = []
  for (const s of shapes) {
    const { shape, holes } = s.extractPoints(6)
    polys.push(shape.map((p) => [p.x, p.y]))
    for (const h of holes) polys.push(h.map((p) => [p.x, p.y]))
  }
  let cs = new CrossSection(polys, 'EvenOdd')
  const b = cs.bounds()
  return cs.translate([-(b.min[0] + b.max[0]) / 2, -(b.min[1] + b.max[1]) / 2])
}
